module.exports = __webpack_public_path__ + "img/slider1.82f8f670.gif";